import { useState, forwardRef, useImperativeHandle, useRef } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { useLanguageContext } from "../../Context/LanguageContext";

const TypeAhead = forwardRef((props, ref) => {
  const [valueInput, setValueInput] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const { localization } = useLanguageContext();
  const {
    typeAheadInputChangeCallback,
    typeAheadSelectedCallback,
    isMultiple,
    searchedList,
    resetSelectedItem,
  } = props;

  const typeRef = useRef("");

  const handleChange = (selected) => {
    if (selected.length > 0) {
      setSelectedItem(selected[0].label);
      setValueInput(selected[0].label);
    }
    typeAheadSelectedCallback(selected);
  };

  const onInputChange = (text, event) => {
    setValueInput(text);
    typeAheadInputChangeCallback(text);
    if (text === "") {
      handleChange("");
    }
  };

  //call from parent component to clear the Input
  useImperativeHandle(ref, () => ({
    resetTypeHead() {
      typeRef.current.clear("");
    },
  }));

  // clear the input if selected item is not match the item in Input
  const handleBlur = (event) => {
    if (valueInput !== selectedItem) {
      typeRef.current.clear("");
      resetSelectedItem();
    }
  };

  return (
    <div className="form-group">
      <Typeahead
        ref={typeRef}
        id="typeahead"
        onChange={handleChange}
        onInputChange={onInputChange}
        multiple={isMultiple}
        placeholder={localization.searchPlaceholder}
        options={searchedList}
        emptyLabel={localization.NotMatchFound}
        className="customTypeAheadCls"
        clearButton={false}
        onBlur={handleBlur}
      />
    </div>
  );
});

export default TypeAhead;
